<template>
	<div>
		<el-dialog title="意向登记表" width="900px" :visible.sync="visible" :close-on-click-modal="false"
			@close="closeDialog">
			<div style="text-align: right; position: absolute; top:20px; right: 100px;">
				<el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
			</div>
			<div>
				<div id="printMe" style="width:750px; margin: 0 auto; position: relative; ">
					<div style=" width: 100%; height: 1063px;">
						<img src="/images/yixiangbiao3.png" style="width: 100%; height: 100%;" />
					</div>
					<div
						style="position: absolute;top: 30px; z-index: 9; border: 2px solid #000; right:60px; width:50px;height: 50px;line-height: 50px; text-align: center;font-size: 20px;border-radius: 50%;">
						{{ stuinfo.exam_num_wlt }}
					</div>
					<div style="position: absolute;top: 0; z-index: 9;">
						<div class="fitem" style="top: 111px;left: 175px;">
							{{ stuinfo.stu_code }}
						</div>

						<div class="fitem" style="top: 132px;left: 175px;">
							{{ stuinfo.stu_name }}
						</div>

						<div class="fitem" style="top: 153px;left: 175px;">
							{{ stuinfo.archive }}
						</div>

						<div class="fitem" style="top: 173px;left: 175px;">
							{{ stuinfo.exam_num }}
						</div>


						<div class="fitem" style="top: 193px;left: 175px;">
							{{ stuinfo.graduate_schname }}
						</div>

						<div class="fitem" style="top: 213px;left: 175px;">
							{{ stuinfo.exam_score }}
						</div>

						<div class="fitem" style="top: 233px;left: 175px;">
							{{ stuinfo.major_name }}
						</div>

						<div class="fitem" style="top: 254px;left: 175px;">
							{{ stuinfo.hkszd }}
						</div>

						<div class="fitem" style="top: 274px;left: 175px;">
							{{ stuinfo.cdate }}
						</div>

						<div class="fitem" style="top: 294px;left: 175px;">
							{{ stuinfo.phone }}
						</div>


						<div class="fitem" style="top: 315px;left: 175px;">
							{{ stuinfo.jhr1name }}
						</div>

						<div class="fitem" style="top: 335px;left: 175px;">
							{{ stuinfo.jhr1phone }}
						</div>
						<div class="fitem" style="top: 355px;left: 175px;">
							{{ stuinfo.remark }}
						</div>

						<div class="fitem" style="top: 735px;left: 585px; width:50px; ">
							<b>{{ stuinfo.exam_num_wlt }}</b>
						</div>






					</div>
					<div class="fitem" style="top: 755px;left: 100px; width: 140px; ">
						{{ stuinfo.stu_name }}
					</div>
					<div class="fitem" style="top: 778px;left: 230px; width: 400px; ">
						{{ stuinfo.major_name }}【{{ stuinfo.xuezhi }}】
					</div>
				</div>

			</div>


		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ["stuinfo"],
	data() {
		return {
			visible: true,
			closing: false

		}
	},
	mounted() {


	},
	methods: {

		closeDialog() {

			this.visible = false;

			setTimeout(() => {
				this.$parent.showYsDialog = false;

			}, 250)
		}
	}
}
</script>

<style scoped>
.fitem {
	position: absolute;

	height: 20px;
	width: 480px;
	line-height: 20px;
	font-size: 14px;
	text-align: center;
	/* background-color: rgba(0, 0, 0, 0.5); */
}
</style>
